export const translation = {
    title: 'Inventory',
    add: 'Add YXMD',
    download: 'Download CSV',
    remove: 'Remove',
    columns: {
        source: 'Source',
        id: 'ID',
        category: 'Category',
        type: 'Type',
        details: 'Details',
        xml: 'XML'
    },
    filters: {
        category: 'Category',
        type: 'Type'
    },
    searchPlaceholder: 'Type to find a node…',
    notes: 'Notes'
};
